import { ReactComponent as Infotip } from './infotip.svg';
import { ReactComponent as ErrorLicensePlates } from './error-license-plates.svg';
import { ReactComponent as TimeSpeed } from './time-speed.svg';
import { ReactComponent as Logo } from './logo.svg';

export const compensaIconsList = {
  Logo,
  Infotip,
  ErrorLicensePlates,
  TimeSpeed,
};
